import { useNavigate } from "react-router-dom";
import ExecutorTaskNotFoundSvgComponent from "../../assets/svg-components/not-found/executor-task";
import "./index.scss";

interface ExecutorTaskNotfoundProps {
  hasLegacyTask?: boolean;
}

export default function ExecutorTaskNotfound({
  hasLegacyTask,
}: ExecutorTaskNotfoundProps) {
  const navigate = useNavigate();

  const handleRedirectToLegacy = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    // Create new params object with transformed date parameters
    const newParams: Record<string, string> = {
      ...params,
      from_date: params.owner_due_date_from || "",
      to_date: params.owner_due_date_to || "",
    };

    // Remove old date parameters if they exist
    delete newParams.owner_due_date_from;
    delete newParams.owner_due_date_to;

    // Filter out empty values and create URLSearchParams
    const filteredParams = Object.fromEntries(
      Object.entries(newParams).filter(([_, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredParams).toString();

    navigate(
      `/repository/legacy-task/executor${queryString ? `?${queryString}` : ""}`
    );
  };

  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/executor-task.svg"
            className="not-found-image img-fluid not-found-image-executor-task"
          /> */}
          <div className="not-found-image img-fluid not-found-image-executor-task">
            <ExecutorTaskNotFoundSvgComponent />
          </div>
          {/* <p className="no-data-found-text">No tasks are mapped for the selected timeframe or filters. Please change date or filter criteria to view information.</p> */}
          <p className="no-data-found-text">
            {hasLegacyTask
              ? "No tasks are mapped for the selected timeframe or filters. However, there are tasks available in the Legacy Tasks."
              : "No tasks are mapped for the selected timeframe or filters. Please change date or filter criteria to view information."}
          </p>

          {hasLegacyTask && (
            <button
              className="btn btn-primary mt-3 p-2"
              onClick={handleRedirectToLegacy}
            >
              View Legacy Tasks
            </button>
          )}
        </div>
      </div>
    </>
  );
}
